import { Link } from "react-router-dom";

const FEATURES = [
  {
    icon: "ri-group-line",
    title: "师兄关系亲疏",
    desc: "大师兄、二师兄与小师弟之间的守护与默契，谁亲谁疏一目了然。",
    to: "/relations",
    tone: "primary",
  },
  {
    icon: "ri-genderless-line",
    title: "师姐互动名场面",
    desc: "大师姐与三师姐的名场面合集，冷热互补、并肩御剑的瞬间全收录。",
    to: "/relations",
    tone: "accent",
  },
  {
    icon: "ri-heart-3-line",
    title: "同门情谊暗线",
    desc: "护短的底色之下，藏着身世与旧怨的暗线，拆解每一处伏笔。",
    to: "/relations",
    tone: "secondary",
  },
  {
    icon: "ri-route-line",
    title: "CP 线发展脉络",
    desc: "从初遇结怨到并肩而行，各 CP 线按节点分集梳理，方便回看名场面。",
    to: "/cp-lines",
    tone: "primary",
  },
];

const TONE: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-700",
  secondary: "bg-secondary-100 text-secondary-700",
};

export default function Features() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
      <div className="mx-auto max-w-2xl text-center">
        <p className="text-xs font-medium tracking-[0.3em] text-primary-600">SHI XIONG A SHI XIONG</p>
        <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
          追更前，先补好这一课
        </h2>
        <div className="gold-line mx-auto mt-4 h-px w-16"></div>
        <p className="mt-4 text-sm leading-7 text-foreground-600">
          《师兄啊师兄》的精彩一半在剧情，一半在人物关系。这里把师兄关系、师姐互动、同门情谊与 CP
          线系统化梳理，让你不错过任何一个名场面背后的伏笔。
        </p>
      </div>

      <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {FEATURES.map((f) => (
          <Link
            key={f.title}
            to={f.to}
            className="group rounded-lg border border-background-200 bg-background-100 p-6 transition-all hover:-translate-y-1 hover:border-primary-200"
          >
            <span
              className={`flex h-12 w-12 items-center justify-center rounded-md ${TONE[f.tone]} text-2xl`}
            >
              <i className={f.icon} />
            </span>
            <h3 className="mt-4 font-heading text-lg text-foreground-950">{f.title}</h3>
            <p className="mt-2 text-sm leading-6 text-foreground-600">{f.desc}</p>
            <span className="mt-4 inline-flex items-center gap-1 text-sm text-primary-600 transition-colors group-hover:text-primary-700">
              前往了解 <i className="ri-arrow-right-line" />
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}